module.exports = __webpack_public_path__ + "static/receipt.4bd9a472.jpg";